// Text-only stream accumulator. Actions are returned by the server in the
// final CommandOutput.actions array (see Phase 10.5 tool_use migration).

export interface StreamParser {
  push(chunk: string): { text: string };
  finish(): { text: string };
}

export function createStreamParser(): StreamParser {
  let text = '';
  return {
    push(chunk: string) {
      text += chunk;
      return { text };
    },
    finish() {
      return { text };
    },
  };
}
